import type { MDXComponents } from 'mdx/types';
import { Section } from '@/components/guide/Section';
import { Callout } from '@/components/guide/Callout';
import { Diagram } from '@/components/guide/Diagram';
import { VideoEmbed } from '@/components/guide/VideoEmbed';
import { FeatureRef } from '@/components/guide/FeatureRef';
import { WalkthroughLink } from '@/components/guide/WalkthroughLink';

export const guideMdxComponents: MDXComponents = {
  Section,
  Callout,
  Diagram,
  VideoEmbed,
  FeatureRef,
  WalkthroughLink,
  // Override default elements
  h2: ({ children, ...props }) => (
    <h2 className="mt-6 mb-3 text-xl font-bold text-guide-text" {...props}>{children}</h2>
  ),
  h3: ({ children, ...props }) => (
    <h3 className="mt-5 mb-2 text-lg font-semibold text-guide-text" {...props}>{children}</h3>
  ),
  p: ({ children, ...props }) => (
    <p className="my-3 text-sm leading-relaxed text-guide-text-soft" {...props}>{children}</p>
  ),
  ul: ({ children, ...props }) => (
    <ul className="my-3 list-disc pl-6 text-sm text-guide-text-soft" {...props}>{children}</ul>
  ),
  ol: ({ children, ...props }) => (
    <ol className="my-3 list-decimal pl-6 text-sm text-guide-text-soft" {...props}>{children}</ol>
  ),
  li: ({ children, ...props }) => <li className="my-1" {...props}>{children}</li>,
};
